import { Component } from '@angular/core';

@Component({
  selector: 'spark-store-details',
  templateUrl: './store-details.component.html',
  styleUrls: ['./store-details.component.scss']
})
export class StoreDetailsComponent {
  constructor() {}

  public onClick(): void {
    window.open('https://store.liberty.com.au/login', '_blank');
  }
}
